import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { C, CONTAINER, FONT, eyebrowSx } from "../accountStyles";



export function initialsOf(first, last) {
  const a = String(first || "").trim().charAt(0);
  const b = String(last || "").trim().charAt(0);
  return `${a}${b}`.toUpperCase();
}

/** Circular monogram with the member's initials. Hidden when there are no initials. */
export function Monogram({ initials, size = { xs: 64, md: 88 } }) {
  if (!initials) return null;
  return (
    <Box
      aria-hidden="true"
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: "50%",
        border: `1px solid ${C.ink}`,
        bgcolor: C.paper,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: FONT,
        fontSize: { xs: "1.35rem", md: "1.9rem" },
        letterSpacing: "1px",
        color: C.ink,
      }}
    >
      {initials}
    </Box>
  );
}


export default function AccountHeader({ eyebrow = "My Account", title, subtitle, initials }) {
  return (
    <Box component="header" sx={{ bgcolor: C.soft, borderBottom: `1px solid ${C.line}` }}>
      <Container maxWidth={CONTAINER} sx={{ py: { xs: 4, md: 7 } }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 2.5, md: 4 } }}>
          <Monogram initials={initials} />
          <Box sx={{ minWidth: 0 }}>
            {eyebrow && <Typography sx={{ ...eyebrowSx, letterSpacing: "3px" }}>{eyebrow}</Typography>}
            <Typography
              component="h1"
              sx={{
                fontFamily: FONT,
                fontWeight: 400,
                fontSize: { xs: "1.85rem", sm: "2.25rem", md: "2.9rem" },
                lineHeight: 1.12,
                color: C.ink,
                mt: 0.75,
                wordBreak: "break-word",
              }}
            >
              {title}
            </Typography>
            {subtitle && (
              <Typography sx={{ fontFamily: FONT, color: C.secondary, fontSize: { xs: "0.9rem", md: "1rem" }, mt: 1, wordBreak: "break-all" }}>
                {subtitle}
              </Typography>
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
